<template>
  <div class="input-data">
    <label>{{ titulo }}:</label>
    <date-picker
      v-model="periodo"
      :lang="lang"
      range
      range-separator=" a "
      format="DD/MM/YYYY"
      :shortcuts="shortcuts"
      :editable="false"
      clearable
      confirm
      confirm-text="Ok"
    ></date-picker>
    <!-- <date-picker
      v-model="time3"
      type="date"
      :lang="lang"
      format="DD/MM/YYYY"
      clearable
      :time-picker-options="timePickerOptions">
    </date-picker>-->
    <!-- <date-picker v-model="time1" valueType="format" :first-day-of-week="1"></date-picker>
    <date-picker v-model="time2" type="datetime" :time-picker-options="timePickerOptions"></date-picker>
    <date-picker v-model="value" :lang="lang"></date-picker>-->
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';

export default {
  name: 'inputData',

  props: {
    titulo: {
      type: String,
      required: true,
    },
    value: Array,
  },

  components: { DatePicker },

  data() {
    return {
      periodo: '',
      // custom lang
      lang: {
        days: ['S', 'T', 'Q', 'Q', 'S', 'S', 'D'],
        months: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        pickers: ['próximos 7 dias', 'próximos 30 dias', '7 dias anteriores', '30 dias anteriores'],
        placeholder: {
          date: 'Selecione a Data',
          dateRange: 'Selecione as datas',
        },
      },
      // custom range shortcuts
      shortcuts: [
        {
          text: 'Hoje',
          onClick: () => {
            this.periodo = [new Date(), new Date()];
          },
        },
      ],
      timePickerOptions: {
        start: '00:00',
        step: '00:30',
        end: '23:30',
      },
    };
  },
  watch: {
    periodo: function(newPeriodo) {
      this.periodo = newPeriodo;

      this.$emit('change', this.periodo);
    },
    value: function(newValue) {
      this.periodo = newValue;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.input-data {
  display: inline-block;
  position: relative;
  margin-right: 40px;
  margin-bottom: 10px;

  & label {
    color: white;
    font-family: 'OpenSans';
    font-size: 13px;
    font-weight: 600;
    margin-right: 10px;
  }

  & /deep/ .mx-input-wrapper {
    & input {
      border-radius: 5px !important;
      color: $cor_amarelo !important;
      background: transparent !important;
      border: 1px solid rgba(white, 0.35) !important;

      &::placeholder {
        color: rgba(white, 0.35) !important;
      }
    }
  }

  & /deep/ .mx-datepicker-popup * {
    font-family: 'OpenSans' !important;
  }
  & /deep/ .mx-calendar-icon {
    color: white;
    opacity: 0.5;
  }
  & /deep/ .mx-clear-icon {
    color: white;
    opacity: 0.5;
  }
  & /deep/ .cell:hover {
    background-color: rgba($cor_roxo, 0.05);
  }
  & /deep/ .cell.actived {
    background-color: $cor_roxo;
  }
  /* & /deep/ .cell.disabled {
    background-color: black
  } */
  & /deep/ .cell.inrange {
    background-color: rgba($cor_roxo, 0.05);
  }
  & /deep/ .today {
    color: $cor_roxo;
    font-weight: bold;
  }
  & /deep/ .mx-shortcuts {
    color: $cor_roxo;
  }
  & /deep/ .mx-current-month {
    color: $cor_roxo;
  }
  & /deep/ .mx-current-year {
    color: $cor_roxo;
  }
  & /deep/ .mx-calendar-header a:hover {
    color: $cor_roxo !important;
  }
  & /deep/ .actived.today {
    color: white !important;
  }
  & /deep/ .mx-datepicker-btn-confirm {
    color: $cor_roxo !important;
    border-color: $cor_roxo !important;
  }
  & /deep/ .mx-datepicker-btn-confirm:hover {
    background-color: rgba($cor_roxo, 0.05);
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .input-data {
    margin-right: 0px;
    margin-bottom: 10px;

    & label {
      font-size: 12px;
    }

    & /deep/ .mx-datepicker {
      position: relative !important;
    }

    & /deep/ .mx-datepicker-popup {
      transform: scale(0.9) !important;
      transform-origin: top left !important;
      left: 0 !important;
      top: 32px !important;
      max-width: 110% !important;
      padding: 0 0% !important;
      border-radius: 5px;
    }

    & /deep/ .mx-shortcuts-wrapper {
      display: none !important;
    }

    & /deep/ .mx-range-wrapper {
      display: flex !important;
      flex-wrap: wrap !important;
      justify-content: center !important;
      align-items: center !important;
      max-width: 100% !important;
    }

    & /deep/ .mx-calendar-panel-date {
      box-shadow: none !important;
      padding: 5% 0px !important;
    }

    & /deep/ .mx-datepicker-range {
      max-width: calc(85vw - 40px) !important;
    }

    & /deep/ .mx-input-wrapper {
      & input {
        font-size: 12px !important;
      }
    }
    & /deep/ .mx-datepicker-btn-confirm {
      position: fixed !important;
      top: -45px !important;
      right: -6px !important;
      background: #609 !important;
      color: white !important;
      border: 0px !important;
      width: 50px !important;
      height: 50px !important;
      text-align: center !important;
      padding: 0px !important;
      margin: 0px !important;
      box-shadow: 0 10px 30px rgba(255, 255, 255, 0.5);
      border-radius: 3px !important;
      font-weight: bold;
    }
    & /deep/ .mx-clear-icon {
      display: none !important;
    }
    & /deep/ .mx-datepicker-footer {
      padding: 0px !important;
      border: 0px !important;
      /* display: none !important */
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
}
</style>
